import React from "react";
import "./CalculatorResults.css";
import { Typography } from "@mui/material";
import { choosingBTdata } from "./data";

const TipTwo = () => {
  // console.log(data);

  return (
    <>
      <section id="right_bt_page_container">
        <section>
          <div className="right_balance_transfer_content pt-4">
            <Typography
              variant="h5"
              style={{
                fontFamily: "'Archivo', sans-serif",
                fontWeight: 700,
                color: "#1F1F1F",
              }}
            >
              {choosingBTdata[0].heading}
            </Typography>
            <Typography
              className="pt-3"
              sx={{
                fontFamily: "'Archivo', sans-serif",
                fontSize: "16px",
                lineHeight: "24px",
                letterSpacing: "normal",
                textAlign: "start",
                color: "#1F1F1F",
              }}
            >
              {choosingBTdata[0].headDescription}
            </Typography>
            <div id="list_data">
              <div id="personal_loan" className="mt-2">
                <Typography
                  sx={{
                    fontFamily: "'Archivo', sans-serif",
                    fontSize: "18px",
                    lineHeight: "24px",
                    letterSpacing: "normal",
                    textAlign: "start",
                    color: "#1F1F1F",
                    fontWeight: 600,
                  }}
                >
                  1.{choosingBTdata[0].subheadOne}
                </Typography>
                <ul
                  style={{
                    listStyle: "disc",
                    fontSize: 16,
                    color: "#1f1f1f",
                    lineHeight: "24px",
                  }}
                  className=" archivo mt-3"
                >
                  {choosingBTdata[0].subheadOneList &&
                    choosingBTdata[0].subheadOneList.map((item, index) => (
                      <li key={index}>
                        <strong>{item.heading}</strong>
                        {item.description}
                      </li>
                    ))}
                </ul>
              </div>
              <div id="transfer_products" className="mt-2">
                <Typography
                  sx={{
                    fontFamily: "'Archivo', sans-serif",
                    fontSize: "18px",
                    lineHeight: "24px",
                    letterSpacing: "normal",
                    textAlign: "start",
                    color: "#1F1F1F",
                    fontWeight: 600,
                  }}
                >
                  2.{choosingBTdata[0].subheadTwo}
                </Typography>
                <ul
                  style={{
                    listStyle: "disc",
                    fontSize: 16,
                    color: "#1f1f1f",
                    lineHeight: "24px",
                  }}
                  className=" archivo mt-3"
                >
                  {choosingBTdata[0].subheadTwoList &&
                    choosingBTdata[0].subheadTwoList.map((item, index) => (
                      <li key={index}>
                        <strong>{item.heading}</strong>
                        {item.description}
                      </li>
                    ))}
                </ul>
              </div>
              <div id="emi_conversion" className="mt-2">
                <Typography
                  sx={{
                    fontFamily: "'Archivo', sans-serif",
                    fontSize: "18px",
                    lineHeight: "24px",
                    letterSpacing: "normal",
                    textAlign: "start",
                    color: "#1F1F1F",
                    fontWeight: 600,
                  }}
                >
                  3.{choosingBTdata[0].subheadThree}
                </Typography>
                <ul
                  style={{
                    listStyle: "disc",
                    fontSize: 16,
                    color: "#1f1f1f",
                    lineHeight: "24px",
                  }}
                  className=" archivo mt-3"
                >
                  {choosingBTdata[0].subheadThreeList &&
                    choosingBTdata[0].subheadThreeList.map((item, index) => (
                      <li key={index}>
                        <strong>{item.heading}</strong>
                        {item.description}
                      </li>
                    ))}
                </ul>
              </div>
              <div id="personal_loan" className="mt-2">
                <Typography
                  sx={{
                    fontFamily: "'Archivo', sans-serif",
                    fontSize: "18px",
                    lineHeight: "24px",
                    letterSpacing: "normal",
                    textAlign: "start",
                    color: "#1F1F1F",
                    fontWeight: 600,
                  }}
                >
                  4.{choosingBTdata[0].subheadFour}
                </Typography>
                <ul
                  style={{
                    listStyle: "disc",
                    fontSize: 16,
                    color: "#1f1f1f",
                    lineHeight: "24px",
                  }}
                  className=" archivo mt-3"
                >
                  {choosingBTdata[0].subheadFourList &&
                    choosingBTdata[0].subheadFourList.map((item, index) => (
                      <li key={index}>
                        <strong>{item.heading}</strong>
                        {item.description}
                      </li>
                    ))}
                </ul>
              </div>
              <div id="personal_loan" className="mt-2">
                <Typography
                  sx={{
                    fontFamily: "'Archivo', sans-serif",
                    fontSize: "18px",
                    lineHeight: "24px",
                    letterSpacing: "normal",
                    textAlign: "start",
                    color: "#1F1F1F",
                    fontWeight: 600,
                  }}
                >
                  5.{choosingBTdata[0].subheadOne}
                </Typography>
                <ul
                  style={{
                    listStyle: "disc",
                    fontSize: 16,
                    color: "#1f1f1f",
                    lineHeight: "24px",
                  }}
                  className=" archivo mt-3"
                >
                  {choosingBTdata[0].subheadFive &&
                    choosingBTdata[0].subheadFiveList.map((item, index) => (
                      <li key={index}>
                        <strong>{item.heading}</strong>
                        {item.description}
                      </li>
                    ))}
                </ul>
              </div>
            </div>
          </div>
        </section>
        <div className="tips mt-3 mb-3">
          <div id="border_line"></div>
          <div id="tip__container" className="px-2 px-sm-4 py-4">
            <div className="px-3 py-2">
              <div className="d-flex flex-row gap-2 align-items-center">
                <img
                  src='/Assets/Images/tongue-out.webp'
                  alt="minemi tip image"
                  style={{ width: 30, height: 30 }}
                />
                <Typography
                  sx={{
                    fontSize: 16,
                    lineHeight: "24px",
                    letterSpacing: "0.08px",
                    color: "#59266D",
                    // color: "yellow",
                    fontFamily: "'Archivo', sans-serif",
                  }}
                >
                  MinEmi Tip
                </Typography>
              </div>
              <div className="mt-2">
                <Typography
                  sx={{
                    fontSize: 16,
                    lineHeight: "24px",
                    letterSpacing: "0.08px",
                    color: "#1F1F1F",
                    // color: "#f8f8f8",

                    fontFamily: "'Archivo', sans-serif",
                  }}
                >
                  {choosingBTdata[0].tipTwo}
                </Typography>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default TipTwo;
